/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LadderChallengeRules
 */
export interface LadderChallengeRules {
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    maxRankDifference?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    cooldownMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    mustAcceptWithinHours?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    autoForfeitHours?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    maxOpenChallenges?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LadderChallengeRules
     */
    allowDecline?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LadderChallengeRules
     */
    minRatingToChallenge?: number;
}

/**
 * Check if a given object implements the LadderChallengeRules interface.
 */
export function instanceOfLadderChallengeRules(value: object): value is LadderChallengeRules {
    return true;
}

export function LadderChallengeRulesFromJSON(json: any): LadderChallengeRules {
    return LadderChallengeRulesFromJSONTyped(json, false);
}

export function LadderChallengeRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderChallengeRules {
    if (json == null) {
        return json;
    }
    return {
        
        'maxRankDifference': json['maxRankDifference'] == null ? undefined : json['maxRankDifference'],
        'cooldownMinutes': json['cooldownMinutes'] == null ? undefined : json['cooldownMinutes'],
        'mustAcceptWithinHours': json['mustAcceptWithinHours'] == null ? undefined : json['mustAcceptWithinHours'],
        'autoForfeitHours': json['autoForfeitHours'] == null ? undefined : json['autoForfeitHours'],
        'maxOpenChallenges': json['maxOpenChallenges'] == null ? undefined : json['maxOpenChallenges'],
        'allowDecline': json['allowDecline'] == null ? undefined : json['allowDecline'],
        'minRatingToChallenge': json['minRatingToChallenge'] == null ? undefined : json['minRatingToChallenge'],
    };
}

export function LadderChallengeRulesToJSON(json: any): LadderChallengeRules {
    return LadderChallengeRulesToJSONTyped(json, false);
}

export function LadderChallengeRulesToJSONTyped(value?: LadderChallengeRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxRankDifference': value['maxRankDifference'],
        'cooldownMinutes': value['cooldownMinutes'],
        'mustAcceptWithinHours': value['mustAcceptWithinHours'],
        'autoForfeitHours': value['autoForfeitHours'],
        'maxOpenChallenges': value['maxOpenChallenges'],
        'allowDecline': value['allowDecline'],
        'minRatingToChallenge': value['minRatingToChallenge'],
    };
}

